<span class="form-input-text">
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+ field) | translate" class="input-label"
    *ngIf="label || field" [hidden]="noLabel"></label>
  <input pInputText [id]="id" (input)="onInput($event)" [value]="formControl['value']"
    [disabled]="formControl['disabled']" [ngClass]="{ 'disabled': formControl['disabled'] }"
    [placeholder]="placeholder || ''" (blur)="onBlur($event)" />
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"
    [duplicated]="formControl.errors?.['duplicated']"
    [forbidden]="formControl.errors?.['forbidden']"
    [email]="formControl.errors?.['email']"></app-form-input-error>
</span>
